import { useBooleanState } from '@cian/react-utils';
import { ArticleParagraph2, CustomTooltip, Label } from '@cian/ui-kit';
import { ChangeEvent, FC, useCallback, useRef } from 'react';
import { useFilterChangeCallback, useSelectorWithConfig, useShowSearchMetaTooltip } from 'shared/hooks';
import { selectEarlyAccessFilter } from 'shared/selectors/filters/earlyAccess';
import { FILTER_KEY } from './constants';
import { SearchResultsTooltip } from 'shared/components/SearchResultsTooltip';
import { CustomCheckbox } from 'shared/components/CustomCheckbox';

export const EarlyAccessContainer: FC = () => {
  const { label, value, description, visible } = useSelectorWithConfig(selectEarlyAccessFilter);

  const { state: isOpen, setTrue, setFalse } = useBooleanState();

  const filterRef = useRef<HTMLLabelElement>(null);

  const onChange = useFilterChangeCallback(FILTER_KEY);

  const handleChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, value: boolean) => {
      onChange({ action: 'setEarlyAccess', arguments: [value || null] });
    },
    [onChange],
  );

  const showTooltip = useShowSearchMetaTooltip(FILTER_KEY);

  if (!visible) {
    return null;
  }

  return (
    <>
      <SearchResultsTooltip open={showTooltip} placement="bottom-start">
        <CustomCheckbox
          ref={filterRef}
          label={label}
          checked={value}
          onChange={handleChange}
          onMouseEnter={setTrue}
          onMouseLeave={setFalse}
          rightAdornment={
            <Label background="accent-negative-primary" color="text-inverted-default">
              Новое
            </Label>
          }
        />
      </SearchResultsTooltip>

      <CustomTooltip
        content={<ArticleParagraph2 whiteSpace="pre-wrap">{description}</ArticleParagraph2>}
        open={isOpen && !showTooltip}
        anchorRef={filterRef}
        portal
        placement="bottom"
      />
    </>
  );
};
